const BASE_URL = "https://staging-api.mindoeducation.co.id"
  // process.env.NODE_ENV === "production"
  //   ? "https://api.mindoeducation.co.id"
  //   : "http://localhost:8000"
export const BASE_URL_IMAGE_PROGRAM = `${BASE_URL}/storage/covers`
export const BASE_URL_IMAGE_TESTIMONI = `${BASE_URL}/storage/testimonial`
export const BASE_URL_ICON_FACILITY = `${BASE_URL}/storage/facility`
export const BASE_URL_API = `${BASE_URL}/api`